import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { Button } from "@bookips/solvook-ui-library";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import Icon from "../../icon/Icon";
import { ArrowRight, Sizes } from "../../icon/IconList";
import React from "react";
export const DetailInfoButton = (infoDialog, productInfo)=>{
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(Button, {
        onClick: ()=>{
            mixpanelEvent("Product Detail Button Clicked", {
                "Product Categories": productInfo.category,
                "Product ID": productInfo.id,
                "Product Title": productInfo.title,
                "Product Price": productInfo.price,
                "Button UI": "Arrow"
            });
            infoDialog.onClickButton();
        },
        children: [
            infoDialog.buttonTitle,
            /*#__PURE__*/ _jsx(Icon, {
                icon: ArrowRight,
                color: theme.palette.primary.main,
                size: Sizes.small
            })
        ]
    });
};
